import moment, { Moment } from 'moment';
import { API_DATE_FORMAT } from './formats';

export class PeriodDateUtils {
  static getDayStringArrayFromPeriod(
    from: string,
    to: string,
    missLastDay: boolean = false
  ): string[] {
    const firstItemDay = moment(from).add(-1, 'days');

    return Array(this.getDayCount(from, to) + (missLastDay ? 0 : 1))
      .fill(null)
      .map(() => firstItemDay.add(1, 'days').format(API_DATE_FORMAT));
  }

  static getDayStringArrayFromDatePeriod(
    from: Date,
    to: Date,
    missLastDay: boolean = false
  ): string[] {
    const firstItemDay = moment(from).add(-1, 'days');

    return Array(this.getDayCount(from, to) + (missLastDay ? 0 : 1))
      .fill(null)
      .map(() => firstItemDay.add(1, 'days').format(API_DATE_FORMAT));
  }

  static getDayCount(
    from: string | Date | Moment,
    to: string | Date | Moment,
    stringDateFormat?: string
  ) {
    return moment(to, stringDateFormat)
      .startOf('day')
      .diff(moment(from, stringDateFormat).startOf('day'), 'days');
  }
}
